// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1nS82","content":"RecentSearches_content__RwleN"};